import { render } from "./BlocksRequiringReview.vue?vue&type=template&id=7b2fe87f&scoped=true"
import script from "./BlocksRequiringReview.vue?vue&type=script&lang=js"
export * from "./BlocksRequiringReview.vue?vue&type=script&lang=js"

import "./BlocksRequiringReview.vue?vue&type=style&index=0&id=7b2fe87f&scoped=true&lang=css"
import "./BlocksRequiringReview.vue?vue&type=style&index=1&id=7b2fe87f&lang=css"

import exportComponent from "C:\\Users\\jenkinsuser\\AppData\\Local\\Jenkins\\.jenkins\\workspace\\UI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b2fe87f"]])

export default __exports__